<template>
    <div class='review-card'>
        <div class='line'></div>
        <div class='top-section'>
            <div>{{review.name}}</div>
            <div>{{review.formatted_date}}</div>
        </div>
        <div class='badges-container'>
            <div v-show='review.verified_purchase == 1'><i class="fa-regular fa-circle-check verified-purchase-icon"></i> Verified purchase</div>
            <div v-show='review.buy_again == 1'><i class="fa-regular fa-circle-check verified-purchase-icon"></i> Would buy again</div>
        </div>
        <div>
            <Ratings :rating='review.rating'/>
        </div>
        <div class='user-review'>
            {{review.review}}
        </div>

        <div class='helpful'>
            <div v-if='logged_in' v-show='show_mark_as_helpful' class='thumb-up' @click='helpfulReview'><i class="fa-light fa-thumbs-up"></i> This review was helpful</div>
            <div v-if='logged_in' v-show='!show_mark_as_helpful'  class='thumb-up'>{{mark_as_helpful_message}}</div>
            <div v-if='!logged_in' class='empty'></div>
            <div><span>{{review.helpful_count}}</span><span v-show='review.helpful_count != 1'> people </span> <span v-show='review.helpful_count == 1'> person </span> found this review helpful</div>
         
        </div>
    </div>
</template>

<script>
import Ratings from '@/ecom/components/products/single_product/reviews/Ratings.vue';
import {checkAuth} from "@/global/modules/functions.js";

export default {
    components:{Ratings},
    props: ['review', 'logged_in'],
    data(){
        return{
            show_mark_as_helpful: true,
            mark_as_helpful_message: ''
        }
    },
    methods:{
        async helpfulReview(){
            let response = await fetch('/api/user-review/mark-as-helpful', {
                method: 'POST',
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    review_id : this.review.id
                }),
            });

            let results = await checkAuth(response);
            if (response.status === 200) {
                if(results.errors.length === 0) {
                    this.review.helpful_count++;
                    this.mark_as_helpful_message = 'Thanks - you have marked this review as helpful';
                } 
                else {
                    this.mark_as_helpful_message = results.errors.helpful_review;
                }

                this.show_mark_as_helpful = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.review-card{
    // width: 1000px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    @media(max-width: 768px){
        width: 80vw;
    }
}

.top-section{
    display: flex;
    justify-content: space-between;
    font-size: 0.96rem;
}

.verified-purchase-icon{
    color: #2b8a3e;
}

.helpful{
    display:flex;
    justify-content: space-between;
    color: var(--primary-colour-1);
    gap: 4px;
}

.line{
    width: 100%;
    height: 1px;
    background-color: #dee2e6;
}

.badges-container{
    display: flex;
    gap: 24px;
}

.thumb-up{
    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }
}
</style>